import { useSocketSynchronizationHandlers } from "@/composables/socket/socket-synchronization-handlers"
import { ProjectGroup } from "@/models/project-group.model"
import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { type IProjectGroup } from "@/interfaces/api/project-group.interface"
import { ProjectGroupRepository } from "@/repositories/project-group-repository"
import { useProjectGroupStore } from "@/store/project-groups.store"
import { storeToRefs } from "pinia"

export class ProjectGroupController extends GenericModelController<
  ProjectGroup,
  IProjectGroup,
  ProjectGroupRepository
> {
  constructor() {
    const projectGroupStore = useProjectGroupStore()
    const { projectGroups } = storeToRefs(projectGroupStore)
    const storeFunctionsConfig = {
      collection: projectGroups
    }

    super(ProjectGroup, storeFunctionsConfig, new ProjectGroupRepository())

    this.socketSynchronizationHandlers = useSocketSynchronizationHandlers(
      ProjectGroup,
      projectGroups
    )
  }
}
